'use strict';

var dsElementCtrl = [function() {    
    var _this = this;

    if (!this.field.type) this.field.type = 'text';
    if (this.field.type == 'graphColumn') this.field.type = 'text';
    if (this.graphColumn) this.field.graphColumn = true;

    // Solo sincroniza linkHTML si el usuario ya eligió "Vincular Reporte"; no cambia tipos guardados
    if (this.field.type === 'linkReport') {
        this.field.linkHTML = true;
    }

    if (['date', 'timestamp'].includes(this.field.type) && this.field.localeAndCutDate) {
        this.field.localeAndCutDate = true;
    }

    if (!this.field.templateData) {
        this.field.templateData = {};
    }

    if (!this.field.templateData.align) this.field.templateData.align = 'left';
    if (this.field.show == undefined) this.field.show = true;

    this.onTypeChange = () => {
        if (_this.field.type === 'linkReport') {
            _this.field.linkHTML = true;
        } else {
            delete _this.field.linkHTML;
        }
        if (!['date', 'timestamp'].includes(_this.field.type)) {
            delete _this.field.localeAndCutDate;
        }
    };

    this.removeColumn = function(id) {
        this.delColumn({
            id: id
        });
    };

    this.toggleCheck = function (field) {
        field.show = !field.show;
        console.log('elements after toggle', _this.elements);
    }

    // console.log('field - elements', this.field, this.elements);
}];

module.exports = function() {
    return {
        restrict: 'E',
        scope: {
            field: '=' ,
            elements: '=',
            graphColumn: '=',
            type: '@',
            delColumn: '&',
        },
        replace: true,
        controller: dsElementCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-graphBuilder/dataSourceIntegrationElementDirective.html'
    };
};
